import { GET_CAREERS, GET_FULL_APP } from "constants/careers";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_FULL_APP}_SUCCESS`:
      return action.payload;
    case `${GET_CAREERS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
